import { withChartLayout } from 'components/common';
import FunctionalDementiaScale from 'components/features/chart/special-charts/functional-dementia-scale/FunctionalDementiaScale';

const FunctionalDementiaScalePage = withChartLayout('Functional Dementia Scale')(FunctionalDementiaScale);
export default FunctionalDementiaScalePage;
